import useTypedContext from "hooks/useTypedContext";

import { StackSettingsVendorComponentBaseProps } from "../types";
import StackSettingsVendorOpenTofuEdit from "./Edit";
import StackSettingsVendorOpenTofuView from "./View";
import { StackSettingsContextData } from "../../Context";

const StackSettingsVendorOpenTofu = (props: StackSettingsVendorComponentBaseProps) => {
  const { canUpdateStack } = useTypedContext(StackSettingsContextData);

  return canUpdateStack.result ? (
    <StackSettingsVendorOpenTofuEdit {...props} />
  ) : (
    <StackSettingsVendorOpenTofuView />
  );
};

export default StackSettingsVendorOpenTofu;
